import { COURSE_ACTION_TYPE } from './Type';


const DEFAULT_STATE = {
	getStartedCourse:  { message: "", status: "idle", data: {} },
};


const INITIAL_STATE = {
	...DEFAULT_STATE,
};


const course = (state = INITIAL_STATE, action) => {
    if (action.type === COURSE_ACTION_TYPE.getStartedCourseFetchingStart) {
        return {
            ...state,
            getStartedCourse: { ...state.getStartedCourse, fetching: true },
        };
    }
    else if (action.type === COURSE_ACTION_TYPE.getStartedCourseFetchingSuccess) {
        return {
            ...state,
            getStartedCourse: action.payload,
        };
    }
    else if (action.type === COURSE_ACTION_TYPE.getStartedCourseIdle) {
        return {
            ...state,
            getStartedCourse: DEFAULT_STATE.getStartedCourse,
        };
    }
    return state;
};

export default course;
